import React, { useEffect } from "react";
import PT from "prop-types";
import { ONBOARDING_NS as BASE_NS } from "@/i18n/ns";
import { Button } from "_c/button";
import { analyticsAction } from "@/utils/analytics";

const OnboardingStep = ({ domain, step, goNext, t }) => {
  const ns = `${BASE_NS}:${domain}.${step}`;
  const img = `/onboarding/${domain}/${step}.gif`;
  useEffect(() => {
    if (domain && step) {
      analyticsAction({
        category: "onboarding_inner",
        action: domain + "_" + step,
      });
    }
  }, [domain, step]);
  return (
    <div
      css={`
        text-align: center;
      `}
    >
      <img
        draggable="false"
        css={`
          width: 360px;
          height: 360px;
          object-fit: cover;
          display: inline-block;
          border-radius: 12px;
          @media (max-width: 370px) {
            width: 310px;
            height: 310px;
            @supports (aspect-ratio: 1 / 1) {
              width: 100%;
              height: auto;
              aspect-ratio: 1 / 1;
            }
          }
        `}
        src={img}
      />
      <h2
        css={`
          color: var(--font-color-emp);
          font-size: 17px;
          font-weight: 700;
          margin-top: 10px;
          margin-bottom: 10px;
        `}
      >
        {t(`${ns}.title`)}
      </h2>
      <p
        css={`
          margin: 0;
          color: var(--font-color-accent);
          line-height: 1.3;
        `}
      >
        {t(`${ns}.text`)}
      </p>
      <div
        css={`
          text-align: center;
          margin-top: 10px;
        `}
      >
        <Button onClick={goNext} greenish small>
          {t(`${ns}.button`)}
        </Button>
      </div>
    </div>
  );
};
OnboardingStep.propTypes = {
  step: PT.string.isRequired,
  domain: PT.string.isRequired,

  goNext: PT.func.isRequired,
  t: PT.func.isRequired,
};
export default OnboardingStep;
